import _toConsumableArray from "/var/lib/jenkins/workspace/HFM_MS_R5.04_May10-CustomerEngage_AM_warfilebuild-PROD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/var/lib/jenkins/workspace/HFM_MS_R5.04_May10-CustomerEngage_AM_warfilebuild-PROD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/lib/jenkins/workspace/HFM_MS_R5.04_May10-CustomerEngage_AM_warfilebuild-PROD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/var/lib/jenkins/workspace/HFM_MS_R5.04_May10-CustomerEngage_AM_warfilebuild-PROD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/var/lib/jenkins/workspace/HFM_MS_R5.04_May10-CustomerEngage_AM_warfilebuild-PROD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/lib/jenkins/workspace/HFM_MS_R5.04_May10-CustomerEngage_AM_warfilebuild-PROD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { isString } from 'vega-util';
import { LATITUDE, LATITUDE2, LONGITUDE, LONGITUDE2, SHAPE } from '../../channel';
import { getFieldOrDatumDef, isDatumDef, isFieldDef, isValueDef } from '../../channeldef';
import { GEOJSON } from '../../type';
import { duplicate, hash as _hash } from '../../util';
import { DataFlowNode } from './dataflow';
export var GeoJSONNode = /*#__PURE__*/function (_DataFlowNode) {
  _inherits(GeoJSONNode, _DataFlowNode);

  var _super = _createSuper(GeoJSONNode);

  function GeoJSONNode(parent, fields, geojson, signal) {
    var _this;

    _classCallCheck(this, GeoJSONNode);

    _this = _super.call(this, parent);
    _this.fields = fields;
    _this.geojson = geojson;
    _this.signal = signal;
    return _this;
  }

  _createClass(GeoJSONNode, [{
    key: "clone",
    value: function clone() {
      return new GeoJSONNode(null, duplicate(this.fields), this.geojson, this.signal);
    }
  }, {
    key: "dependentFields",
    value: function dependentFields() {
      var _a;

      var fields = ((_a = this.fields) !== null && _a !== void 0 ? _a : []).filter(isString);
      return new Set([].concat(_toConsumableArray(this.geojson ? [this.geojson] : []), _toConsumableArray(fields)));
    }
  }, {
    key: "producedFields",
    value: function producedFields() {
      return new Set();
    }
  }, {
    key: "hash",
    value: function hash() {
      return "GeoJSON ".concat(this.geojson, " ").concat(this.signal, " ").concat(_hash(this.fields));
    }
  }, {
    key: "assemble",
    value: function assemble() {
      return Object.assign(Object.assign(Object.assign({
        type: 'geojson'
      }, this.fields ? {
        fields: this.fields
      } : {}), this.geojson ? {
        geojson: this.geojson
      } : {}), {
        signal: this.signal
      });
    }
  }], [{
    key: "parseAll",
    value: function parseAll(parent, model) {
      if (model.component.projection && !model.component.projection.isFit) {
        return parent;
      }

      var geoJsonCounter = 0;

      for (var _i = 0, _arr = [[LONGITUDE, LATITUDE], [LONGITUDE2, LATITUDE2]]; _i < _arr.length; _i++) {
        var coordinates = _arr[_i];
        var pair = coordinates.map(function (channel) {
          var def = getFieldOrDatumDef(model.encoding[channel]);
          return isFieldDef(def) ? def.field : isDatumDef(def) ? {
            expr: "".concat(def.datum)
          } : isValueDef(def) ? {
            expr: "".concat(def['value'])
          } : undefined;
        });

        if (pair[0] || pair[1]) {
          parent = new GeoJSONNode(parent, pair, null, model.getName("geojson_".concat(geoJsonCounter++)));
        }
      }

      if (model.channelHasField(SHAPE)) {
        var fieldDef = model.typedFieldDef(SHAPE);

        if (fieldDef.type === GEOJSON) {
          parent = new GeoJSONNode(parent, null, fieldDef.field, model.getName("geojson_".concat(geoJsonCounter++)));
        }
      }

      return parent;
    }
  }]);

  return GeoJSONNode;
}(DataFlowNode);